import { PAGE_SIZES } from '@/constants/pagination';

export const VAULT_PAGE_SIZE = PAGE_SIZES.STANDARD;

type VaultPageRangeInput = {
  page: number;
  pageSize: number;
  total: number;
};

export const getVaultPageRange = ({
  page,
  pageSize,
  total,
}: VaultPageRangeInput) => {
  if (total === 0) return { from: 0, to: 0 };
  return {
    from: page * pageSize + 1,
    to: Math.min((page + 1) * pageSize, total),
  };
};
